import React, { useState } from "react";
import _ from "lodash";

import { Checkbox } from "../../form-inputs/inputs";

const ColumnChooser = ({ type, userColumns, resetColumns, updateUserColumns }) => {
    const [columns, setColumns] = useState(_.cloneDeep(userColumns));

    const updateColumns = (name, value) => {
        const newColumns = { ...columns };
        newColumns[name].value = value;
        setColumns(newColumns);
    };

    const saveColumns = () => {
        updateUserColumns(columns);
    };

    const checkboxes = Object.keys(columns)
        .filter((key) => {
            const visibleFor = columns[key].visibleFor;

            if (visibleFor && Array.isArray(visibleFor)) {
                return visibleFor.some((taskType) => type === taskType);
            }

            return true;
        })
        .map((k) => {
            return <Checkbox key={k} name={k} value={columns[k].value} label={columns[k].label} updateOnChange={updateColumns} />;
        });

    return (
        <div className="column-chooser">
            <h3>Column Chooser</h3>
            <p>Select the columns you wish to display.</p>
            <br />
            <div className="available-columns">{checkboxes}</div>
            <div className="button-group -right">
                <button className="button" onClick={resetColumns}>
                    Reset to Default
                </button>
                <button className="button -primary" onClick={saveColumns}>
                    Save
                </button>
            </div>
        </div>
    );
};

export default ColumnChooser;
